import {
  phosphorArrowRight,
  phosphorArrowUpRight,
  phosphorBank,
  phosphorBriefcase,
  phosphorBuildings,
  phosphorCaretDown,
  phosphorChartLineUp,
  phosphorCheck,
  phosphorCircle,
  phosphorCircleNotch,
  phosphorDiamond,
  phosphorEnvelopeSimple,
  phosphorFileText,
  phosphorGear,
  phosphorHouse,
  phosphorInstagramLogo,
  phosphorLinkedinLogo,
  phosphorList,
  phosphorMapPin,
  phosphorMoon,
  phosphorPaperPlaneTilt,
  phosphorPlus,
  phosphorShieldCheck,
  phosphorSignOut,
  phosphorSquaresFour,
  phosphorSun,
  phosphorTrendUp,
  phosphorWarningCircle,
  phosphorX,
  phosphorXLogo,
} from '@ng-icons/phosphor-icons/regular';

/** The single icon family for v3 (Phosphor, regular weight). Register with `provideIcons(CP_ICONS)`. */
export const CP_ICONS = {
  phosphorArrowRight,
  phosphorArrowUpRight,
  phosphorBank,
  phosphorBriefcase,
  phosphorBuildings,
  phosphorCaretDown,
  phosphorChartLineUp,
  phosphorCheck,
  phosphorCircle,
  phosphorCircleNotch,
  phosphorDiamond,
  phosphorEnvelopeSimple,
  phosphorFileText,
  phosphorGear,
  phosphorHouse,
  phosphorInstagramLogo,
  phosphorLinkedinLogo,
  phosphorList,
  phosphorMapPin,
  phosphorMoon,
  phosphorPaperPlaneTilt,
  phosphorPlus,
  phosphorShieldCheck,
  phosphorSignOut,
  phosphorSquaresFour,
  phosphorSun,
  phosphorTrendUp,
  phosphorWarningCircle,
  phosphorX,
  phosphorXLogo,
};

